<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M30 42.3848L34.2426 38.1421L20.1005 24L34.2426 9.85786L30 5.61522L15.8579 19.7574L11.6152 24L15.8579 28.2426L30 42.3848Z" />
</svg>
